"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TIMESYNC_PROP = void 0;

var _react = _interopRequireDefault(require("react"));

var _timeSync = _interopRequireDefault(require("time-sync"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TIMESYNC_PROP = "$$_TIME_SYNC_HIDDEN_$$";
exports.TIMESYNC_PROP = TIMESYNC_PROP;
var timeSync = new _timeSync.default();

var _default = /*#__PURE__*/_react.default.createContext({
  getCurrentTime: _timeSync.default.getCurrentTime,
  getTimeLeft: _timeSync.default.getTimeLeft,
  addTimer: timeSync.addTimer,
  createCountdown: timeSync.createCountdown
});

exports.default = _default;